const getZeroDiscount = (recommendation) => {
  const { discounted, value } = recommendation.price;
  return discounted && discounted.value.centAmount === value.centAmount ? {
    key: null,
    value: discounted.discount.description
  } : void 0;
};
export {
  getZeroDiscount
};
//# sourceMappingURL=get-zero-discount.js.map
